import { Host, h } from "@stencil/core";
export class ChNotificationsItem {
    constructor() {
        this.buttonImgSrc = undefined;
        this.closeButtonLabel = undefined;
        this.leftImgSrc = undefined;
        this.showCloseButton = true;
        this.timeToDismiss = 5000;
    }
    /**
     * Used to not fire an extra event when the control is dismissed before the
     * dismiss timeout is called.
     */
    timeout;
    element;
    /**
     *
     */
    notificationClick;
    /**
     *
     */
    notificationDismiss;
    handleNotificationDismiss = (mustClearTimeout = false) => () => {
        if (mustClearTimeout) {
            clearTimeout(this.timeout);
        }
        this.notificationDismiss.emit(Number(this.element.id));
    };
    handleNotificationClick = (mustClearTimeout = false) => () => {
        if (mustClearTimeout) {
            clearTimeout(this.timeout);
        }
        this.notificationClick.emit(Number(this.element.id));
    };
    componentDidLoad() {
        this.timeout = setTimeout(this.handleNotificationDismiss(false), this.timeToDismiss);
    }
    render() {
        return (h(Host, null, h("button", { class: "main", part: "notification-item__main", type: "button", onClick: this.handleNotificationClick(true) }, this.leftImgSrc && (h("img", { "aria-hidden": "true", alt: "", src: this.leftImgSrc, loading: "lazy" })), h("slot", null)), this.showCloseButton && (h("button", { "aria-label": this.closeButtonLabel, class: !this.buttonImgSrc ? "close-image" : undefined, part: "notification-item__close-button", type: "button", onClick: this.handleNotificationDismiss(true) }, this.buttonImgSrc && (h("img", { "aria-hidden": "true", alt: "", src: this.buttonImgSrc, loading: "lazy" }))))));
    }
    static get is() { return "ch-notifications-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["notifications-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["notifications-item.css"]
        };
    }
    static get properties() {
        return {
            "buttonImgSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "button-img-src",
                "reflect": false
            },
            "closeButtonLabel": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "close-button-label",
                "reflect": false
            },
            "leftImgSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "left-img-src",
                "reflect": false
            },
            "showCloseButton": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "`true` to show the close notification button"
                },
                "attribute": "show-close-button",
                "reflect": false,
                "defaultValue": "true"
            },
            "timeToDismiss": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "5000",
                    "resolved": "5000",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "attribute": "time-to-dismiss",
                "reflect": false,
                "defaultValue": "5000"
            }
        };
    }
    static get events() {
        return [{
                "method": "notificationClick",
                "name": "notificationClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }, {
                "method": "notificationDismiss",
                "name": "notificationDismiss",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=notifications-item.js.map
